import React, {useState} from 'react';
import {Box, VStack} from '@chakra-ui/react';
import {TextG14} from '../../../components/typography';
import {PublicProfileConversationStarter} from '../../../hooks/usePublicProfile';

const INITIAL_VISIBLE = 3;

interface ConversationStarterCardsProps {
  starters: PublicProfileConversationStarter[];
  onMessage: () => void;
}

const ConversationStarterCards = ({starters, onMessage}: ConversationStarterCardsProps) => {
  const [showAll, setShowAll] = useState(false);

  if (starters.length === 0) return null;

  const visible = showAll ? starters : starters.slice(0, INITIAL_VISIBLE);
  const hiddenCount = starters.length - INITIAL_VISIBLE;

  return (
    <Box px={4} mb={6}>
      <VStack spacing={3} align="stretch">
        {visible.map(({prompt, answer}, i) => (
          <Box
            key={i}
            border="1px solid #E5E5E5"
            borderRadius="12px"
            p={4}
            position="relative"
            boxShadow="0 0 16px 0 rgba(0, 0, 0, 0.08)">
            <TextG14 mt="0" color="#555" lineHeight="18px" mb={1}>
              {prompt}
            </TextG14>
            <TextG14 mt="0" fontWeight="700" lineHeight="22px" pr="40px">
              {answer}
            </TextG14>
            <Box
              position="absolute"
              right="16px"
              bottom="16px"
              w="36px"
              h="36px"
              borderRadius="full"
              bg="#F4F4F4"
              display="flex"
              alignItems="center"
              justifyContent="center"
              cursor="pointer"
              _hover={{bg: '#E8E8E8'}}
              onClick={onMessage}>
              <i className="fi fi-rr-paper-plane" aria-hidden="true" style={{fontSize: '14px', color: '#1A1A1A'}} />
            </Box>
          </Box>
        ))}
      </VStack>
      {!showAll && hiddenCount > 0 && (
        <TextG14
          mt="12px"
          color="#1A1A1A"
          fontWeight="600"
          cursor="pointer"
          onClick={() => setShowAll(true)}>
          +{hiddenCount} more conversation starter{hiddenCount > 1 ? 's' : ''}
        </TextG14>
      )}
    </Box>
  );
};

export default ConversationStarterCards;
